var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home-contain"},[_c('video-banner',{on:{"change-play":_vm.handleVedio}}),_c('mission'),_c('product-service'),_c('news-service')],1)}
var staticRenderFns = []

export { render, staticRenderFns }